import { useEffect, useRef, useState } from "react";

export default function HoverMenu({
  button,
  children,
  align = "left",
}: {
  button: React.ReactNode;
  children: React.ReactNode;
  align?: "left" | "right";
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const timer = useRef<number | null>(null);

  function openNow() {
    if (timer.current) window.clearTimeout(timer.current);
    setOpen(true);
  }
  function closeSoon() {
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setOpen(false), 120);
  }

  useEffect(() => {
    const onEsc = (e: KeyboardEvent) => e.key === "Escape" && setOpen(false);
    document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, []);

  return (
    <div
      ref={ref}
      className="relative"
      onMouseEnter={openNow}
      onMouseLeave={closeSoon}
    >
      <div className="inline-flex">{button}</div>
      <div
        className={`absolute ${align === "right" ? "right-0" : "left-0"} mt-2 min-w-64
          bg-white rounded-2xl border border-slate-100 shadow-[0_10px_30px_rgba(0,0,0,.12)] overflow-hidden
          transition ${open ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 -translate-y-1 pointer-events-none"}`}
      >
        {children}
      </div>
    </div>
  );
}